<template>
  <div>
    <div class="select-option-container mt-10px w-100 d-flex-end" :style="{ backgroundImage: 'url(' + img + ')' }">
      <div :style="{ backgroundImage: 'url(' + img + ')' }" class="img-responsive">
      </div>
      <div class="p-60px d-flex vertical-center responsive-container d-flex-end  col-40">
        <CustomSelect :options="options" :label="label" class="select-position" v-model="result"
          @update:modelValue="(e) => $emit('update:modelValue', e)"></CustomSelect>
      </div>
    </div>
  </div>
</template>
<script>
import CustomSelect from '@/components/form/CustomSelect.vue'
export default {
  data() {
    return {
      result: null
    };
  },
  components: {
    CustomSelect
  },
  props: {
    img: String,
    label: String,
    options: Array,
    modelValue: String
  },
  methods: {
    addTo(nb) {
      this.results[nb]++;
    },
    removeTo(nb) {
      this.results[nb]--;
    },
  },
  watch: {
    modelValue(newVal) {
      this.result = newVal;
    }
  }
};
</script>
<style scoped>
.select-option-container {
  position: relative;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-bottom-right-radius: 50px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  background-size: auto 100%;
  background-repeat: no-repeat;
  min-height: 350px;
}

.description-nb {
  font-family: var(--font);
  color: var(--text-color);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.2px;
}

.select-position {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.flex-grow-1 {
  flex: 1;
  width: 100%;
}

@media screen and (max-width: 1300px) {
  .p-60px {
    padding: 20px;
  }

}

@media screen and (max-width: 800px) {
  .img-responsive{
    display: block !important;
    box-sizing:border-box;
    background-size:cover;
    background-position: top center;
    background-repeat: no-repeat;
    min-height:350px;
    width:100%;
  }
  .select-option-container {
    background-image: none !important;
  }

  .select-option-img {
    width: 100%;
  }

  .select-option-img>img {
    width: 100%;
  }

  .col-40 {
    width: 100%;
  }

  .select-position {
    width: 90%;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
}
</style>